// Short, non-cryptographic hash of "this moment" — unique enough for a filename, no backend round-trip needed.
export const momentHash = () => {
  const input = `${Date.now()}-${Math.random()}`;
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(16);
};

export default momentHash;
